var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InventoryTableShowBlock',{attrs:{"Inventory":_vm.Inventory,"filteredArray":_vm.filteredArray,"navTabs":_vm.navTabs},on:{"changeTab":_vm.changeTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }